export default "/images/d2477ce730ee0cac32cd2ad5de8e5eb3.avif";